import styled from 'styled-components';
import {Assign} from 'utility-types';

// TYPES
import {ThemeProps} from 'styled-components';

// COMPONENTS
import {Link} from 'react-router-dom';

// THEME
import {Theme} from '../../../../../stories/theme/types';

import {listItemSEOProps} from './Breadcrumb';

export const ArrowWrapper = styled.span(
  props => `
  height: 1rem;
  width: 1rem;
  font-size:${props.theme.font.small};
  padding: 0 ${props.theme.spacing.base};
  color: ${props.theme.colors.downriver.dark};
`,
);

export const OuterWrapperDiv = styled.section(
  props => `

  background-color: ${props.theme.colors.goWhite.base};

`,
);

export const BreadCrumbContainer = styled.div(
  // itemscope and item type are html attributes directly passed to section
  (props: Assign<ThemeProps<Theme>, {itemScope: boolean; itemType: string}>) => `
  display: flex;
  width: 100%;
  flex-direction: row;
  max-width: 120rem;
  margin: 0 auto;
  padding: ${props.theme.spacing.xlarge} 0;
  // align-items: center;
`,
);

export const BreadCrumbList = styled.ol`
  list-style-type: none;
  display: flex;
  align-items: center;
`;

export const BreadCrumbItemLink = styled(Link)(
  props => `
  display: flex;
  cursor: pointer;
  text-decoration: none;
  color: ${props.theme.colors.goBrandBlue.base}
  &:hover{
    color: ${props.theme.colors.goBrandBlue.base}
  }
  &.active{
    color: ${props.theme.colors.goWhite.base}
  }
`,
);

export const BreadCrumbATagItemLink = styled.a(
  props => `
  display: flex;
  cursor: pointer;
  text-decoration: none;
  color: ${props.theme.colors.goBrandBlue.base}
  &:hover{
    color: ${props.theme.colors.goBrandBlue.base}
  }
  &.active{
    color: ${props.theme.colors.goWhite.base}
  }
`,
);

export const NoLinkBreadcrumbListItem = styled.li(
  (props: Assign<ThemeProps<Theme>, typeof listItemSEOProps>) => `
  display: flex;
  text-decoration: none;
  color: ${props.theme.colors.downriver.base}
`,
);
